import { render } from "./DonnePersonnelle.vue?vue&type=template&id=507a3f32&ts=true"
import script from "./DonnePersonnelle.vue?vue&type=script&lang=ts"
export * from "./DonnePersonnelle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__